export const MIN_DAY_WIDTH = 40; // ~~ 900 for 4 weeks
export const MAX_SPACE_FOR_LABEL = 220;
export const PADDING = 30;
export const LINE_HEIGHT = 40;
export const TOP_PADDING = 75;
export const LEFT_PADDING = 5;
export const BAR_HEIGHT = 30;
/** Reject persisted day widths above this; zoom UI max is ~3× planning pane width (see ZoomMenu). */
export const MAX_CUSTOM_DAY_WIDTH_SANITY = 100_000;
/** Ignore rubber-band widths below this (CSS px) so zoom scale stays finite and matches other zoom UI limits. */
export const MIN_GANTT_SELECTION_WIDTH = 8;

export const SPACE_BETWEEN_BARS = 10;
export const SPACE_BETWEEN_BARS_WATERFALL = 0;
export const SHIFTS_PER_DAY = 3;
export const SHIFT_H = 8;
export const SHIFTS_IN_WEEK = SHIFTS_PER_DAY * 7;
export const MIN_DAYS = 60;
